import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import api from "api";
import { formatDate, formatPrice } from "utils";
import { Link } from "react-router-dom";
import { FiDownload, FiRefreshCw, FiList, FiEdit2 } from "react-icons/fi";
export default function AdminOrderModal({
  show,
  order,
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!show || !order?.orderId) {
      return;
    }
    setLoading(true);
    setError(null);
    api
      .get("/admin/orders/" + order.orderId)
      .then((res) => {
        setData(res.data || null);
      })
      .catch(() => {
        setError("Impossible de charger la commande");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [show, order]);
  const customer = data?.customer || {};
  const items = data?.items || [];
  const payments = data?.payments || [];
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Commande {data?.formatedInvoiceNumber || ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div>
            Chargement...
          </div>
        )}
        {error && (
          <div className="text-danger">
            {error}
          </div>
        )}
        {!loading && !error && data && (
          <div className="container-fluid">



            <div className="row g-4">

              <div className="col-md-4">
                <div className="card">
                  <div className="card-header">
                    Commande
                  </div>
                  <div className="card-body small">
                    <div>
                      <strong>Numéro :</strong>{" "}
                      {data.formatedInvoiceNumber}
                    </div>
                    <div>
                      <strong>Date :</strong>{" "}
                      {formatDate(data.orderDate)}
                    </div>
                    <div>
                      <strong>Statut :</strong>{" "}
                      {data.orderStatus}
                    </div>
                    <div>
                      <strong>Paiement :</strong>{" "}
                      {data.orderPaymentMode}
                      {data.orderPaymentStatus === 'processing' && <span className="text-red"> (virement en cours)</span>}
                    </div>
                    <div>
                      <strong>Total TTC :</strong>{" "}
                      {formatPrice(data.orderTotalPriceIT)} €
                    </div>
                    <div>
                      <strong>Solde :</strong>{" "}
                      {formatPrice(data.orderBalance)} €
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">

                <div className="card">
                  <div className="card-header">
                    Client
                  </div>
                  <div className="card-body small">
                    <div>
                      <strong>
                        {customer.userFirstname} {customer.userName}
                      </strong>
                    </div>
                    {customer.userCompName && (
                      <div>
                        {customer.userCompName}
                      </div>
                    )}
                    <div>
                      {customer.userEmail}
                    </div>
                    <div>
                      {customer.userPhone}
                    </div>
                    <div>
                      {customer.userAddress}
                    </div>
                    <div>
                      {customer.userPostcode} {customer.userCity}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <div className="card-header">
                    Facturation
                  </div>
                  <div className="card-body small">
                    <div>
                      <strong>
                        {data.orderBillingFirstname}{" "}
                        {data.orderBillingLastname}
                      </strong>
                    </div>
                    {data.orderBillingCompany && (
                      <div>
                        {data.orderBillingCompany}
                      </div>
                    )}
                    <div>
                      {data.orderBillingEmail}
                    </div>
                    <div>
                      {data.orderBillingAddress}
                    </div>
                    <div>
                      {data.orderBillingPostcode}{" "}
                      {data.orderBillingCity}
                    </div>
                    <div>
                      {data.orderBillingCountry}
                    </div>
                    {data.orderBillingVATNumber && (
                      <div className="mt-2">
                        <strong>TVA :</strong>{" "}
                        {data.orderBillingVATNumber}
                      </div>
                    )}
                  </div>
                </div>


              </div>

            </div>





            <div className="mt-4">

              <div className="card">

                <div className="card-header">
                  Lignes de commande
                </div>

                <div className="card-body p-0">

                  <table className="table table-sm mb-0 align-middle">

                    <thead>

                      <tr>
                        <th>Prestation</th>
                        <th className="text-end">Honoraires HT</th>
                        <th className="text-end">Débours</th>
                        <th className="text-end">TVA</th>
                        <th className="text-end">TTC</th>
                        <th className="text-end"></th>
                      </tr>

                    </thead>

                    <tbody>

                      {items.map((item) => (

                        <tr key={item.itId}>

                          <td>



                            <div>

                              <div className="fw-semibold">
                                {item.itProdName}
                              </div>


                            </div>





                          </td>




                          <td className="text-end">
                            {formatPrice(item.itTaxableAmountET)} €
                          </td>

                          <td className="text-end">
                            {formatPrice(item.itNonTaxableAmountIT)} €
                          </td>

                          <td className="text-end">
                            {formatPrice(item.itVATAmount)} €
                          </td>

                          <td className="text-end fw-semibold">
                            {formatPrice(item.itTotalPriceIT)} €
                          </td>
                          <td className="text-end">
                            {item.itProdType === "FormalityRequest" && (


                              <Link
                                to={`/admin/formalities/request/${item.itProdId}`}
                                target="_blank"
                                className="text-primary"
                              >
                                <FiEdit2 />
                              </Link>

                            )}</td>
                        </tr>

                      ))}

                    </tbody>

                    <tfoot>

                      <tr>
                        <th colSpan="4" className="text-end">
                          Total HT
                        </th>

                        <th className="text-end">
                          {formatPrice(data.orderTotalPriceET)} €
                        </th>
                      </tr>

                      <tr>
                        <th colSpan="4" className="text-end">
                          TVA
                        </th>

                        <th className="text-end">
                          {formatPrice(data.orderVATAmount)} €
                        </th>
                      </tr>

                      <tr>
                        <th colSpan="4" className="text-end">
                          Total TTC
                        </th>

                        <th className="text-end">
                          {formatPrice(data.orderTotalPriceIT)} €
                        </th>
                      </tr>

                      <tr>
                        <th colSpan="4" className="text-end">
                          Payé
                        </th>

                        <th className="text-end text-success">
                          {formatPrice(data.orderTotalPaid)} €
                        </th>
                      </tr>

                      <tr>
                        <th colSpan="4" className="text-end">
                          Solde
                        </th>

                        <th className="text-end">
                          {formatPrice(data.orderBalance)} €
                        </th>
                        <th></th>
                      </tr>

                    </tfoot>

                  </table>

                </div>

              </div>

            </div>
            <div className="mt-4">
              <div className="card">
                <div className="card-header">
                  Paiements
                </div>
                <div className="card-body p-0">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Mode</th>
                        <th className="text-end">Montant</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.length === 0 && (
                        <tr>
                          <td
                            colSpan="3"
                            className="text-center"
                          >
                            Aucun paiement
                          </td>
                        </tr>
                      )}
                      {payments.map((payment) => (
                        <tr key={payment.payId}>
                          <td>
                            {formatDate(payment.payCreatedAt)}
                          </td>
                          <td>
                            {payment.payMode}
                          </td>
                          <td className="text-end">
                            {formatPrice(payment.payAmount)} €
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div >
        )
        }
      </Modal.Body >
    </Modal >
  );
}